// Event delegation: supports dynamically loaded content + multiple wrappers per page
document.addEventListener('click', function (e) {
  // Find the clicked button (if any)
  const button = e.target.closest('.size-guide-wrapper .size-toggle-buttons button');
  if (!button) return;

  // Find the wrapper this button belongs to
  const wrapper = button.closest('.size-guide-wrapper');
  if (!wrapper) return;

  const target = button.getAttribute('data-target');
  if (!target) return;

  // Toggle active button (scoped to this wrapper only)
  wrapper.querySelectorAll('.size-toggle-buttons button').forEach(btn => {
    btn.classList.remove('active');
  });
  button.classList.add('active');

  // Show the matching table (scoped to this wrapper only)
  wrapper.querySelectorAll('.size-table').forEach(tbl => {
    const isMatch = tbl.getAttribute('data-table') === target;
    tbl.classList.toggle('active', isMatch);
  });
});
